import { inject, Injectable } from '@angular/core';
import { REMOTE_CONFIG_TOKEN, RemoteConfigKeys, RemoteConfigProvider, RemoteConfigValueType } from '@core';
import { VersionConfigData } from '../../models/version-config.model';

@Injectable({ providedIn: 'root' })
export class VersionDataService {
  private readonly remoteConfigProvider: RemoteConfigProvider = inject(REMOTE_CONFIG_TOKEN);

  async fetchConfig(): Promise<VersionConfigData | null> {
    try {
      const [newestVersion, availableVersions] = await Promise.all([
        this.remoteConfigProvider.getValue<string>(
          RemoteConfigKeys.NEWEST_VERSION,
          RemoteConfigValueType.STRING,
          '0.0.0'
        ),
        this.remoteConfigProvider.getValue<string[]>(
          RemoteConfigKeys.AVAILABLE_VERSIONS,
          RemoteConfigValueType.JSON,
          []
        )
      ]);

      return { newestVersion, availableVersions };
    } catch {
      return null;
    }
  }
}
